import { useEffect, useState , useContext} from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import CurrencyFormat from "react-currency-format";
import TextField from "@mui/material/TextField";
import { NumericFormat } from "react-number-format";
import { Switch } from "antd";
import { accountService } from "../../services/accountService";
import Select from "react-select";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import LogicContext from "../../Context/LogicContext";
import BankChargeAccountHeadSelect from "./BankChargeAccountHeadSelect";
import DelgroProgressBar from "../../generals/DelgroProgressBar";
import ChargeAccountSelect from "./ChargeAccountSelect";


const customStyles = {
  control: (base, state) => ({
    ...base,
    backgroundColor: "#f9fafb", // Tailwind: bg-gray-50
    borderColor: state.isFocused ? "#0000FF" : "#d1d5db", // gray-400 or gray-300
    boxShadow: state.isFocused ? "0 0 0 1px #9ca3af" : "none", // subtle gray ring
    // "&:hover": {
    //   borderColor: "#9ca3af", // gray-400
    // },
    height: 42,
    // border: 4,
    borderRadius: 6, // rounded-md
    paddingLeft: 4,
    paddingRight: 4,
    fontSize: 14,
    width: "50%",
    transition: "all 0.2s ease-in-out",
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0 8px",
  }),
  placeholder: (base) => ({
    ...base,
    color: "#9ca3af", // gray-400
  }),
  singleValue: (base) => ({
    ...base,
    color: "#111827", // gray-900
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    color: state.isFocused ? "#6b7280" : "#9ca3af", // gray-500/gray-400
    "&:hover": {
      color: "#6b7280", // gray-500
    },
  }),
  menu: (base) => ({
    ...base,
    backgroundColor: "#ffffff", // white dropdown
    borderRadius: 6,
    boxShadow: "0 4px 14px rgba(0, 0, 0, 0.05)",
    marginTop: 4,
    fontSize: 14,
    boxShadow: "0 0 0 1px #d1d5db",
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? "#FFFFFF" // gray-200
      : state.isFocused
      ? "#f3f4f6" // gray-100
      : "#ffffff", // white
    color: "#111827", // gray-900
    padding: "8px 12px",
    cursor: "pointer",
    borderColor: state.isFocused ? "#9ca3af" : "#d1d5db", // gray-400 or gray-300
    "&:hover": {
      backgroundColor: "#f3f4f6", // gray-400
    },
    border: "2px",
    transition: "background-color 0.2s ease",
  }),
};


 
const BankChargeMainPage = () => {
  const [tableData, setTableData] = useState({ account_head_info:[], bank_info:[]  });
  const [tableDataBackUp, setTableDataBackUp] = useState({ account_head_info:[], bank_info:[]  });
      // const [defOption, setDefOption] = useState(null);
      const [optionList, setOptionList] = useState([]);
        const myPromiseModal = createModal(GeneralModal);
          const logicContext = useContext(LogicContext);
        
  

  useEffect(()=> {

    accountService.getBankChargeData().then((res)=> {
      const accData = res?.data;
      if(accData){
        setTableData(accData);
        setTableDataBackUp(accData);
        let newList = accData.account_head_info.map((item) => {
          return { ...item, label: item?.Bank_Charge_Account_Name };
        });
        setOptionList(newList);
        if (newList?.length) {
        }
      }
    })

  },[]);

  const onAccountTypeSelect = (type) => {
    const selType =  type?.Account_Main_Id;
    const newList = tableDataBackUp.chart_of_accounts.filter((acc)=> acc.Account_Main_Id === selType);
    setTableData((prev)=> {
      return {...prev, chart_of_accounts: newList};
    })
  }


  const onBankChargePercentChange = (debVal, acc) => {
    let tempDataAccount =  tableData?.bank_info.map((account) =>{
      if(acc.Deposit_Mode_Id ===  account?.Deposit_Mode_Id){
        return {...account,Bank_Charge_Percentage: debVal }
      }else{
        return account;
      }
    });
      setTableData(prevData => ({
        ...prevData, bank_info:tempDataAccount }));
      
  }
  const onBankAdditionalChange = (debVal, acc) => {
    let tempDataAccount =  tableData?.bank_info.map((account) =>{
      if(acc.Deposit_Mode_Id ===  account?.Deposit_Mode_Id){
        return {...account,Additional_Charge_Amount: debVal }
      }else{
        return account;
      }
    });
      setTableData(prevData => ({
        ...prevData, bank_info:tempDataAccount }));
      
  }


  const onMaximumAmountChange = (debVal, acc) => {
    let tempDataAccount =  tableData?.bank_info.map((account) =>{
      if(acc.Deposit_Mode_Id ===  account?.Deposit_Mode_Id){
        return {...account,Maximum_Bank_Charge_Amount: debVal }
      }else{
        return account;
      }
    });
      setTableData(prevData => ({
        ...prevData, bank_info:tempDataAccount }));
  }


  const saveAllAccount = async ()=> {
    const response = await myPromiseModal({
      title: "Save All Account",
      body: " All modified accounts will be saved!",
      showInput: false,
      placeHolder: "",
    });

    if (response.decision === true) {
      let xml_string = "";
      let temp = "";
      tableData?.bank_info?.map((acc, i) => {
        temp += `<a><deposit_mode_id>${acc?.Deposit_Mode_Id} </deposit_mode_id> <bank_charge_account_id>${acc?.Bank_Charge_Account_Id} </bank_charge_account_id> <max_charge_amount>${acc?.Maximum_Bank_Charge_Amount} </max_charge_amount>
         <charge_percentage>${acc?.Bank_Charge_Percentage} </charge_percentage> <additional_charge_amount>${acc?.Additional_Charge_Amount} </additional_charge_amount><account_id>${acc?.Account_Id} </account_id>  </a>`;
      });
      xml_string = `<root> ${temp} </root>`;
    
      accountService.updateBankCharges({xml_string: xml_string}).then((response)=> {
        const cleanResponse =  logicContext.httpResponseManager(response.data?.[0] || response.data?.result_status?.[0]);

     logicContext.showToast(cleanResponse?.message_text, 'success');
        
      }).catch((err)=> {
        console.log("Error...", err);
      })
    }

  }

  const onChargeAccSelect = (selection, acc) => {
    let tempDataAccount =  tableData?.bank_info.map((account) =>{
      if(acc.Deposit_Mode_Id ===  account?.Deposit_Mode_Id){
        return {...account,Bank_Charge_Account_Id: selection?.Bank_Charge_Account_Id}
      }else{
        return account;
      }
    });
      setTableData(prevData => ({
        ...prevData, bank_info:tempDataAccount }));
  }

  const onAccountHeadSelect = (selection, acc) => {
    let tempDataAccount =  tableData?.bank_info.map((account) =>{
      if(acc.Deposit_Mode_Id ===  account?.Deposit_Mode_Id){
        return {...account,Account_Id: selection?.Account_Id}
      }else{
        return account;
      }
    });
      setTableData(prevData => ({
        ...prevData, bank_info:tempDataAccount }));
  }



    return (
        <>
        <section className="mt-2" >
          {!tableDataBackUp?.account_head_info &&  <DelgroProgressBar/> }
         

          <span>
<h6 class="mb-1 font-extrabold leading-none tracking-tight text-gray-900 md:text-2xl lg:text-2xl dark:text-white">Bank Charge Page</h6>
          </span>

           

          <TableContainer component={Paper} className="overflow-hidden">
  <div className=" mb-4 px-4">
    <div className="grid grid-cols-1 gap-4">
      {/* Optional: Additional filters/inputs here */}
    </div>
  </div>

  <Table aria-label="customized table" className="min-w-full">
    <TableHead>
      <TableRow className="bg-gray-200 ">
        {["Mode of Payment", "Account Head", "Bank Charge Account", "Bank Charge (%)","Additional Amt", "Maximum Amount"].map((header, index) => (
          <TableCell
            key={index}
            className=" font-bold text-md font-bold text-gray-700 px-6 py-3 border-b border-gray-300"
          >
            {header}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
    <TableBody>
      {tableData.bank_info?.map((acc, i) => (
        <TableRow key={i} className="hover:bg-gray-50 transition">
          {/* Account Name */}
          <TableCell className="text-xs text-gray-800 px-6 py-3 border-b border-gray-200">
            <div title={acc.Depoist_Mode_Name} className="font-bold max-w-xs truncate cursor-default">
              {acc.Depoist_Mode_Name}
            </div>
          </TableCell>

            {/* Account head) */}
            <TableCell className="text-xs text-gray-800 px-6 py-3 border-b border-gray-200">
  <div className="max-w-[200px] w-full">
             {/* Put Select Here */}  
             <BankChargeAccountHeadSelect defaultVal={acc?.Account_Name} list={tableDataBackUp.account_head_info}
              onMainAccSelect={(sel)=> onAccountHeadSelect(sel, acc)} />
            </div>
          </TableCell>

          {/* Bank charge Acc */}
          <TableCell className="text-xs text-gray-800 px-6 py-3 border-b border-gray-200">
  <div className="max-w-[200px] w-full">
             {/* Put Select Here */}  
             <ChargeAccountSelect defaultVal={acc?.Bank_Charge_Account_Name} list={tableDataBackUp.account_charge_head_info}
              onMainAccSelect={(sel)=> onChargeAccSelect(sel, acc)} />
            </div>
          </TableCell>

          {/* Debit */}
          <TableCell className="text-xs text-gray-800 px-6 py-3 border-b border-gray-200 text-right">
            <NumericFormat
              value={acc?.Bank_Charge_Percentage}
              className="h-8 w-[100px] border border-gray-300 rounded text-right px-2"
              thousandSeparator=","
              decimalSeparator="."
              onValueChange={(values) => {
                onBankChargePercentChange(values.value, acc);
              }}
            />
          </TableCell>


          {/* Additional Amt */}
          <TableCell className="text-xs text-gray-800 px-6 py-3 border-b border-gray-200 text-right">
            <NumericFormat
              value={acc?.Additional_Charge_Amount}
              className="h-8 w-[100px] border border-gray-300 rounded text-right px-2"
              thousandSeparator=","
              decimalSeparator="."
              onValueChange={(values) => {
                onBankAdditionalChange(values.value, acc);
              }}
            />
          </TableCell>

          {/* Credit */}
          <TableCell className="text-xs text-gray-800 px-6 py-3 border-b border-gray-200 text-right">
            <NumericFormat
              value={acc?.Maximum_Bank_Charge_Amount}
              className="h-8 w-[100px] border border-gray-300 rounded text-right px-2"
              thousandSeparator=","
              decimalSeparator="."
              onValueChange={(values) => {
                onMaximumAmountChange(values.value, acc);
              }}
            />
          </TableCell>

        </TableRow>
      ))}
    </TableBody>
  </Table>

  <div className="flex justify-end mt-4 mb-4 px-4">
    <button
      onClick={() => saveAllAccount()}
      className="bg-blue-600 text-white hover:bg-blue-700 flex items-center text-sm font-medium px-4 py-2 rounded-md transition"
    >
      SAVE ALL
    </button>
  </div>
</TableContainer>

        </section>
        
        </>
      );
}
 
export default BankChargeMainPage;